import React, { Component } from 'react';
import { $ } from 'rype-bootstrap';
import { compose } from 'redux';
import { connect } from 'react-redux';
import ModalDecorator from 'hocs/ModalDecorator';

import ActiveSubscriptionsSelector from '../../../selectors/ActiveSubscriptionsSelector';
import { pauseMembership } from '../../../actions/userActions';

import Loading from '../../Loading/Loading';
import { RadioGroup, Radio } from '../../Radio';
import { MAX_PAUSE_WEEKS } from '../../../config/constants';
import './style.css';

const PAUSE_PERIOD = {
  ONE_WEEK: 'one_week',
  TWO_WEEKS: 'two_weeks',
  FOUR_WEEKS: 'four_weeks'
};

class PauseMembershipModal extends Component {
  constructor() {
    super();

    $.noConflict();

    this.state = {
      selectedPeriod: PAUSE_PERIOD.ONE_WEEK,
      errorMessage: null
    };
  }

  componentDidMount() {
    // the HOC ModalDecorator adds and removes this modal from the DOM.
    //
    // once the component mounts, we need to manually add call show
    // to force Bootstrap to render the modal
    //
    // the delay is present to smooth the transitions
    // while the component continues to load
    setTimeout(() => $('#pause-membership-modal').modal('show'), 75);

    // set up an event listener to call this.props.closeModal
    // whenever the modal is hidden.
    // closeModal comes from ModalDecorator, and causes
    // the element to be removed from the DOM
    $('#pause-membership-modal').on('hidden.bs.modal', () => {
      this.props.closeModal();
    });
  }

  getPauseWeeks = () => {
    const { customer } = this.props;

    if (customer) {
      return parseInt(customer.customFields.field3.value, 10) || 0;
    }
    return 0;
  }

  handlePauseMembership = () => {
    const activeSubscription = this.props.activeStripeSubscriptions.data;
    if (activeSubscription) {
      this.props.pauseMembership(
        activeSubscription.stripeSubscriptionId,
        this.props.stripeCustomer.id,
        activeSubscription.stripePlanId,
        this.state.selectedPeriod,
        () => {
          this.close();
        },
        res => {
          this.setState({ errorMessage: res.message || 'Unexpected error' });
        }
      );
    }
  }

  handleChange = (value) => {
    this.setState({ selectedPeriod: value });
  }

  close = () => {
    // Call 'hide' to reset all the Bootstrap styling
    $('#pause-membership-modal').modal('hide');
  }

  checkPauseAvailable = (period) => {
    const pauseWeeks = this.getPauseWeeks();

    switch (period) {
      case PAUSE_PERIOD.ONE_WEEK:
        return MAX_PAUSE_WEEKS - pauseWeeks > 0;
      case PAUSE_PERIOD.TWO_WEEKS:
        return MAX_PAUSE_WEEKS - pauseWeeks > 1;
      case PAUSE_PERIOD.FOUR_WEEKS:
        return MAX_PAUSE_WEEKS - pauseWeeks > 3;
      default:
        return true;
    }
  }

  renderRadio(period, label) {
    const isDisabled = !this.checkPauseAvailable(period);
    return (
      <Radio
        value={period}
        label={label}
        className={isDisabled ? 'disabled' : ''}
        disabled={isDisabled}
      />
    );
  }

  render() {
    return (
      <div
        id="pause-membership-modal"
        className="PauseMembershipModal modal fade"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="pause-membership-label"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-body text-center">
              <img src="/assets/snooze.png" alt="snooze" className="mb-3" />
              <h5>
                Need to take a breather?
                <br />
                Take a break for up to 4 weeks, and you won&#39;t be charged while you&#39;re on pause.
              </h5>
              <div>
                Pause my account for:
                <div className="radio-group text-left">
                  <RadioGroup
                    name="pause-membership"
                    selectedValue={this.state.selectedPeriod}
                    onChange={this.handleChange}
                  >
                    {this.renderRadio(PAUSE_PERIOD.ONE_WEEK, '1 week')}
                    {this.renderRadio(PAUSE_PERIOD.TWO_WEEKS, '2 weeks')}
                    {this.renderRadio(PAUSE_PERIOD.FOUR_WEEKS, '4 weeks')}
                  </RadioGroup>
                </div>
                {this.props.pauseStatus === 'LOADING' ? (
                  <Loading />
                ) : (
                  <button
                    type="button"
                    className="btn btn-primary btn-cursor btn-gray"
                    onClick={this.handlePauseMembership}
                  >
                    Pause Membership
                  </button>
                )}
                {this.state.errorMessage && (
                  <p className="text-danger mt-2">{this.state.errorMessage}</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    customer: state.customer,
    pauseStatus: state.user.pauseStatus,
    stripeCustomer: state.stripeCustomer,
    activeStripeSubscriptions: ActiveSubscriptionsSelector(state)
  };
}

export default compose(
  ModalDecorator('pause-membership-modal'),
  connect(
    mapStateToProps,
    { pauseMembership }
  )
)(PauseMembershipModal);



// WEBPACK FOOTER //
// ./src/components/modals/PauseMembershipModal/index.js